import { createTheme } from "@mui/material/styles";
import typography from "./typography";

/* eslint-disable import/no-unresolved, import/no-webpack-loader-syntax */
import vars from "!!sass-vars-to-js-loader!../assets/core/_variables-mui.scss";

export const colorDefinitions = {
  text1:            { light: '#3b3e66', dark: '#d4d6d7' }, // navy text
  accent1:          { light: '#0088e8', dark: '#47b3ff' },
  accent2:          { light: '#f66f27', dark: '#f66f27' },
  active:           { light: '#eeeeee', dark: '#5b5b5b' }, // active event
  border:           { light: '#c4c4c4', dark: '#6e6e6e' },
  paper:            { light: '#fff',    dark: '#424242' }, // tooltip paper
  grey1:            { light: '#dedfe3', dark: '#343434' }, // card background grey
  grey2:            { light: '#dedfe3', dark: '#5b5b5b' }, // avatar bcackground
  grey3:            { light: '#999999', dark: '#7c7c7c' }, // tooltip border color
  grey4:            { light: '#f9f9f9', dark: '#393939' }, // very light grey
  grey5:            { light: '#f5f5f5', dark: '#515151' }, // light grey used in menu hover
  grey6:            { light: '#666',    dark: '#999'    }, // text lighter
  formPlaceholder:  { light: '#999',    dark: '#999'    },
  siteBackground:   { light: '#e5e5e5', dark: '#212325' },
  siteTextColor:    { light: '#3f3f3f', dark: '#ccc'    },
  primary:          { light: '#0153a3', dark: '#778eeb' },
  secondary:        { light: '#1e8dfa', dark: '#1e8dfa' },
  info:             { light: '#2196f3', dark: '#2196f3' },
  success:          { light: '#43a047', dark: '#43a047' },
  error:            { light: '#d32f2f', dark: '#d32f2f' },
  warning:          { light: '#ff9800', dark: '#ff9800' },
  helpersPrimary:   { light: 'blue',    dark: 'blue'    },
  second:           { light: '#070919', dark: '#070919' },
  topNavBg:         { light: '#d5d5d5', dark: '#12181e' },
  tableBorder:      { light: '#eee',    dark: '#525252' },
  tableNthRow:      { light: '#f9f8f8', dark: '#474747' },
  helpersMain:      { light: 'rgba(25, 46, 91, .035)', dark: 'rgba(25, 46, 91, .035)'   },
  shadow1:          { light: 'rgba(0, 0, 0, 0.5)',     dark: 'rgba(255, 255, 255, 1)'   },
  disabledBtn:      { light: 'rgba(255, 255, 255, 0.4)', dark: 'rgba(255, 255, 255, 0.5)' },
}

export const DayTheme = createTheme({
  palette: {
    mode: "light",
    text: {
      primary: "#3b3e66",
    },
    colors: {
      text1: "#3b3e66",
      grey1: "#dedfe3",
      label: "#3b3e66",
      borderColor: vars.bgElementsLight,
      chipBg: vars.bgElementsLight,
      borderColorList: "#B5B5B5",
    },
    // default: {
    //   main: vars.primary
    // },
    primary: {
      main: vars.primary,
    },
    topBar: {
      main: "#FFFEFC",
      submenu: "#1977D4",
      underline: "#FFFEFC",
    },
    grey: {
      300: vars.inheritDefault1,
      A100: vars.inheritDefault2,
    },
    secondary: {
      main: vars.secondary,
    },
    error: {
      main: "#d32f2f",
      light: "#d32f2f",
      dark: "rgb(179, 39, 39)",
    },
    success: {
      main: vars.green,
    },
    warning: {
      main: vars.orange,
    },
    helpers: {
      primary: vars.blue,
      main: "rgba(25, 46, 91, .035)",
    },
    customBg: "#1977D4",
    bg: vars.bgLight,
    bgElements: vars.bgElementsLight,
    colorFont: "#000",
    toolbarColor: vars.primary,
    contrastThreshold: 3,
    tonalOffset: 0.1,
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "normal",
        },
        text: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
        containedSizeSmall: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: vars.second,
          padding: "8px 16px",
          fontSize: "13px",
        },
        arrow: {
          color: vars.second,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: "#1976d2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem 0.7rem 1rem 1.5rem",
          color: vars.inheritDefault1,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            // color: "#000",
          },
          "& .MuiInputBase-root": {
            // color: "#000",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiInputBase-input": {
            color: "#000", // Set desired text color here
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "& .MuiOutlinedInput-root": {
            maxHeight: "50px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            // color: "#000",
          },
          "& .MuiSelect-select": {
            // color: "#000",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          color: "#000",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          marginTop: "1em",
          marginBottom: "1em",
        },
        selectLabel: {
          marginTop: "1em",
          marginBottom: "1em",
        },
      },
    },
  },
  typography,
  colors: {
    errorContrast: "#ffffff",
    grey1: "#dedfe3",
  },
  card: {
    bg: "#fff",
    hr: "#dedfe3",
    warrantColor: "#D33D1D",
  },
  button: {
    color: "#1976d2",
  },
  accordion: {
    background: "#fff",
    backgroundColor: "#d5d5d5",
    textColor: "#3b3e66",
  },
  content: {
    bg: "#e5e5e5",
  },
});

export const NightTheme = createTheme({
  palette: {
    mode: "dark",
    text: {
      primary: "#d4d6d7",
      button: "#d4d6d7",
    },
    // default: {
    //   main: '#d4d6d7'
    // },
    primary: {
      main: vars.primary,
    },
    topBar: {
      main: "#1977D4",
      submenu: "#1977D4",
      topBar: "#1977D4",
    },
    grey: {
      300: vars.inheritDefault1,
      A100: vars.inheritDefault2,
    },
    secondary: {
      main: vars.secondary,
    },
    error: {
      main: "#d32f2f",
      light: "#d32f2f",
      dark: "rgb(179, 39, 39)",
    },
    success: {
      main: vars.green,
    },
    warning: {
      main: vars.orange,
    },
    helpers: {
      primary: vars.blue,
      main: "rgba(25, 46, 91, .035)",
    },
    bg: vars.bgDark,
    customBg: "#515151",
    bgElements: vars.bgElementsDark,
    colorFont: "#fff",
    toolbarColor: "#748EEB",
    contrastThreshold: 3,
    tonalOffset: 0.1,
    colors: {
      grey1: "#343434",
      borderColor: "#7c7c7c",
      chipBg: vars.bgElementsLight,
      text1: "#d4d6d7",
      label: "#d4d6d7",
      borderColorList: "#7c7c7c",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": { color: "#fff" },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": { color: "#fff" },
        },
      },
    },
    MuiButton: {
      backgroundColor: "#515151",
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "normal",
        },
        text: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
        containedSizeSmall: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: vars.second,
          padding: "8px 16px",
          fontSize: "13px",
        },
        arrow: {
          color: vars.second,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        regular: {
          minHeight: "80px",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: "#1976d2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem 0.7rem 1rem 1.5rem",
          color: vars.inheritDefault1,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            // color: "#fff",
          },
          "& .MuiInputBase-root": {
            // color: "#fff",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiInputBase-input": {
            color: "#fff", // Set desired text color here
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "& .MuiOutlinedInput-root": {
            maxHeight: "50px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            // color: "#fff",
          },
          "& .MuiSelect-select": {
            // color: "#fff",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212",
          color: "#fff",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          marginTop: "1em",
          marginBottom: "1em",
        },
        selectLabel: {
          marginTop: "1em",
          marginBottom: "1em",
        },
      },
    },
  },
  typography,
  colors: {
    errorContrast: "#f7f7f7",
    grey1: "#343434",
  },
  card: {
    bg: "#fff",
    hr: "#343434",
    warrantColor: "#D33D1D",
  },
  button: {
    color: "#fff",
  },
  accordion: {
    background: "#424242",
    backgroundColor: "#1e2e3a",
    textColor: "#d4d6d7",
  },
  content: {
    bg: "#212325",
  },
});
